import { Modal } from "antd";
import { showError } from "common/ToastNotifications";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import DuplicateDataObjectMergeRulesBuilder from "components/organisms/DuplicateDataObjectMergeRulesBuilder";
import { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Action, Dispatch } from "redux";
import actions from "store/actions";
import AppState from "store/AppState";
import NominatedValueSelectionList from "./NominatedValueSelectionList";

const mapStateToProps = (state: AppState) => {
    return {
        getSchemaModelResult: state.schemaModels.getSchemaModelResult,
        schemaModel: state.schemaModels.schemaModel,
        getDuplicateMergeRulesResult: state.dataObjectDuplicateMergeRules.getDuplicateMergeRulesResult,
        duplicateMergeRulesResult: state.dataObjectDuplicateMergeRules.duplicateMergeRulesResult,
        saveDuplicateMergeRulesResult: state.dataObjectDuplicateMergeRules.saveDuplicateMergeRulesResult,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action<string>>) => {
    return {
        getSchemaModel: (businessAreaId: string, schemaId: string) => dispatch(actions.getSchemaModelRequest(businessAreaId, schemaId)),
        getDuplicateMergeRules: (duplicateSetId: string, duplicateSetVersion: string, groupId: string, dataObjectId: string) =>
            dispatch(actions.getDuplicateMergeRulesRequest(duplicateSetId, duplicateSetVersion, groupId, dataObjectId)),
        saveDuplicateMergeRules: (duplicateSetId: string, duplicateSetVersion: string, groupId: string, dataObjectId: string, rules: IDataObjectMergeRule[]) =>
            dispatch(actions.saveDuplicateMergeRulesRequest(duplicateSetId, duplicateSetVersion, groupId, dataObjectId, rules)),
    };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type IPropsFromRedux = ConnectedProps<typeof connector>;

interface IDataObjectDuplicateMergeRulesProps extends IPropsFromRedux {
    businessAreaId?: string;
    schemaId?: string;
    duplicateSetId?: string;
    duplicateSetVersion?: string;
    groupId?: string;
    dataObjectId?: string;
    dataObjectGroup?: IDataObjectRecord[];
    onClose: () => void;
}

interface IDataObjectDuplicateMergeRulesStates {
    fetchingSchema: boolean;
    fetchingRules: boolean;
    showMergeRules: boolean;
    busy: boolean;
    busyMessage: string;
    savingRules: boolean;
    nominatedValueParams: {
        formField: {
            name: string;
        };
        fieldName: string;
        formRef: any;
        nominatedValue: string;
    } | null;
}

class DataObjectDuplicateMergeRules extends Component<IDataObjectDuplicateMergeRulesProps & RouteComponentProps, IDataObjectDuplicateMergeRulesStates> {
    constructor(props: IDataObjectDuplicateMergeRulesProps & RouteComponentProps) {
        super(props);
        this.state = {
            fetchingSchema: true,
            fetchingRules: true,
            showMergeRules: true,
            busy: false,
            busyMessage: "Please wait...",
            savingRules: false,
            nominatedValueParams: null,
        };
    }

    componentWillMount() {}

    componentDidMount() {
        this.setState({
            fetchingSchema: true,
            fetchingRules: true,
        });
        if (this.props.businessAreaId && this.props.schemaId) {
            this.props.getSchemaModel(this.props.businessAreaId, this.props.schemaId);
        }
        if (this.props.duplicateSetId && this.props.duplicateSetVersion && this.props.groupId && this.props.dataObjectId) {
            this.props.getDuplicateMergeRules(this.props.duplicateSetId, this.props.duplicateSetVersion, this.props.groupId, this.props.dataObjectId);
        }
    }

    componentDidUpdate(prevProps: IDataObjectDuplicateMergeRulesProps & RouteComponentProps, prevState: unknown, snapshot: unknown) {
        this.onGetSchemaModelResultChanged(prevProps);
        this.onGetDuplicateMergeRulesResultChanged(prevProps);
        this.onSaveDuplicateMergeRulesResultChanged(prevProps);
    }

    onGetSchemaModelResultChanged = (prevProps: IDataObjectDuplicateMergeRulesProps & RouteComponentProps) => {
        if (this.props.getSchemaModelResult && this.props.getSchemaModelResult !== prevProps.getSchemaModelResult) {
            if (!this.props.getSchemaModelResult.success) {
                showError("Unable to get schema at this moment");
            }
            this.setState({
                fetchingSchema: false,
            });
        }
    };

    onGetDuplicateMergeRulesResultChanged = (prevProps: IDataObjectDuplicateMergeRulesProps & RouteComponentProps) => {
        if (this.props.getDuplicateMergeRulesResult && this.props.getDuplicateMergeRulesResult !== prevProps.getDuplicateMergeRulesResult) {
            if (!this.props.getDuplicateMergeRulesResult.success) {
                showError("Unable to get rules at this moment");
            }
            this.setState({
                fetchingRules: false,
            });
        }
    };

    onSaveDuplicateMergeRulesResultChanged = (prevProps: IDataObjectDuplicateMergeRulesProps & RouteComponentProps) => {
        if (this.props.saveDuplicateMergeRulesResult && this.props.saveDuplicateMergeRulesResult !== prevProps.saveDuplicateMergeRulesResult) {
            if (!this.props.saveDuplicateMergeRulesResult.success) {
                showError("Unable to saved rules at this moment");
            } else {
                this.setState({
                    showMergeRules: false,
                });
                this.props.onClose();
            }
            this.setState({
                savingRules: false,
            });
        }
    };

    onOkClicK = () => {
        this.setState({
            showMergeRules: false,
        });
        this.props.onClose();
    };

    onCancelClick = () => {
        this.setState({
            showMergeRules: false,
        });
        this.props.onClose();
    };

    onSaveRules = (rules: IDataObjectMergeRule[]) => {
        this.setState({
            busyMessage: "Saving rules...",
            savingRules: true,
        });
        if (this.props.duplicateSetId && this.props.duplicateSetVersion && this.props.groupId && this.props.dataObjectId) {
            this.props.saveDuplicateMergeRules(this.props.duplicateSetId, this.props.duplicateSetVersion, this.props.groupId, this.props.dataObjectId, rules);
        }
    };

    isBusy = () => {
        let isBusy = this.state.busy || this.state.fetchingSchema || this.state.fetchingRules || this.state.savingRules;
        return isBusy;
    };

    onSelectNominatedValueClick = (formField: { name: string }, fieldName: string, nominatedValue: string, formRef: any) => {
        this.setState({
            nominatedValueParams: {
                formField,
                fieldName,
                formRef,
                nominatedValue,
            },
        });
    };

    onSelectNominatedValueCancelClick = () => {
        this.setState({
            nominatedValueParams: null,
        });
    };

    onSelectNominatedValueOkClick = (selectedValue: string) => {
        if (selectedValue && this.state.nominatedValueParams) {
            let formData = { ...this.state.nominatedValueParams.formRef.current.getFieldsValue() };
            formData.rules[this.state.nominatedValueParams.formField.name].nominatedValue = selectedValue;
            this.state.nominatedValueParams.formRef.current.setFieldsValue(formData);
        }
        this.setState({
            nominatedValueParams: null,
        });
    };

    render() {
        return (
            <Modal
                destroyOnHidden={true}
                closable={false}
                maskClosable={false}
                keyboard={false}
                title="Merge Rules"
                style={{ top: 20 }}
                open={this.state.showMergeRules}
                onOk={this.onOkClicK}
                onCancel={this.onCancelClick}
                styles={{
                    body: { height: "80vh", minHeight: "50vh" },
                }}
                width="80%"
                footer={null}
            >
                {this.isBusy() ? (
                    <FlexContainerLayout contentClassName="overflow-hidden">
                        <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                    </FlexContainerLayout>
                ) : (
                    <FlexContainerLayout>
                        <DuplicateDataObjectMergeRulesBuilder
                            schemaModel={this.props.schemaModel}
                            rules={this.props.duplicateMergeRulesResult.Items}
                            onClose={this.onCancelClick}
                            onSaveRules={this.onSaveRules}
                            onSelectNominatedValueClick={this.onSelectNominatedValueClick}
                        ></DuplicateDataObjectMergeRulesBuilder>
                        {this.state.nominatedValueParams && (
                            <NominatedValueSelectionList
                                dataObjectGroup={this.props.dataObjectGroup}
                                fieldName={this.state.nominatedValueParams.fieldName}
                                selectedValue={this.state.nominatedValueParams.nominatedValue}
                                onCancelClick={this.onSelectNominatedValueCancelClick}
                                onOkClick={this.onSelectNominatedValueOkClick}
                            ></NominatedValueSelectionList>
                        )}
                    </FlexContainerLayout>
                )}
            </Modal>
        );
    }
}

export default connector(withRouter(DataObjectDuplicateMergeRules));
